"use client";
import { MapPanel, MapPopout } from "@/components";

export function MapSidePanel({
  mapRef,
  selectedMarker,
  isModalOpen,
  daysOfShow,
  showDates,
  categories,
  zoomAwaySelectedLoc,
  setActiveCategory,
  activeCategory,
  filteredLocations,
  zoomToSelectedLoc,
  setHoveredLocation,
  hoveredLocation,
  searchWord,
  setSearchWord,
  showSearch,
  setShowSearch,
  setActivateBounce,
}) {
  function toggleCategory(category) {
    setActiveCategory(activeCategory === category.slug ? "all" : category.slug);
  }

  const topCategories = [
    "live-entertainment",
    "first-aid",
    "toilet",
    "shopping",
    "atm",
    "dining-catering-precinct",
  ];

  categories.sort((a, b) => a.slug.localeCompare(b.slug));

  categories.sort((a, b) => {
    if (topCategories.includes(a.slug) && topCategories.includes(b.slug)) {
      return topCategories.indexOf(a.slug) - topCategories.indexOf(b.slug);
    } else if (topCategories.includes(a.slug)) {
      return -1;
    } else if (topCategories.includes(b.slug)) {
      return 1;
    } else {
      return 0;
    }
  });

  return (
    <div className="h-full hidden lg:block p-8 absolute left-0 top-0 bottom-0 w-[500px] animate-slide-in-left">
      <div className="relative flex flex-col justify-start w-full h-full p-8 overflow-hidden bg-brand-wool rounded-lg shadow-10xl animate-fade-in">
        <MapPanel
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          searchWord={searchWord}
          setSearchWord={setSearchWord}
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          categories={categories}
          filteredLocations={filteredLocations}
          setHoveredLocation={setHoveredLocation}
          hoveredLocation={hoveredLocation}
          setActivateBounce={setActivateBounce}
          zoomToSelectedLoc={zoomToSelectedLoc}
          toggleCategory={toggleCategory}
        />
        <MapPopout
          mapRef={mapRef}
          zoomAwaySelectedLoc={zoomAwaySelectedLoc}
          selectedMarker={selectedMarker}
          daysOfShow={daysOfShow}
          showDates={showDates}
          isModalOpen={isModalOpen}
        />
      </div>
    </div>
  );
}
